// Messages list page (CHG-1262 / ITER-3387).
//
// Thin per v2-canary: page file ≤30 LOC, configuration in @generated/screens.
// Future generator regenerates messageListConfig from message.entity-hint.yaml
// (CHG-1237) without touching this file.
//
// Spec: specs/tier-05-experience/messages-v2.cross-screen.yaml.
// Point-in-time entity (5th canary using the recipe) — NO StageChip /
// NO ambient row, mirrors CHG-1243/1249/1251/1254.

import { ListPage } from "../components/composition";
import { messageListConfig } from "../generated/screens/message-list";

export function Messages() {
  return <ListPage config={messageListConfig} />;
}
